// Icon — lucide-react 아이콘 래퍼.
// size·color props를 CSS 변수 기반 기본값으로 통일한다.
// 직접 lucide import 대신 이 컴포넌트를 통해 사용하면
// 전체 아이콘 크기 조정 시 이 파일 한 곳만 수정하면 된다.

import type { LucideIcon, LucideProps } from 'lucide-react';

// 아이콘 크기 프리셋
export type IconSize = 'sm' | 'md' | 'lg';

const SIZE_MAP: Record<IconSize, number> = {
  sm: 14,  // 작은 영역 (배지 옆, 작은 버튼)
  md: 16,  // 기본 (인라인 텍스트, 목록)
  lg: 20,  // 큰 영역 (주요 버튼, 헤더)
};

interface IconProps extends Omit<LucideProps, 'size'> {
  /** 렌더할 lucide-react 아이콘 컴포넌트 */
  icon: LucideIcon;
  /** 프리셋 크기 (기본 md = 16px) */
  size?: IconSize;
  /** aria-hidden 기본 true — 장식 아이콘은 숨김. 의미 있는 아이콘은 aria-label 사용 */
  'aria-hidden'?: boolean | 'true' | 'false';
}

export function Icon({
  icon: LucideComponent,
  size = 'md',
  'aria-hidden': ariaHidden = true,
  ...rest
}: IconProps) {
  return (
    <LucideComponent
      size={SIZE_MAP[size]}
      aria-hidden={ariaHidden}
      {...rest}
    />
  );
}

// 편의 re-export — 자주 쓰는 아이콘을 Named export로 모아 트리셰이킹 보장
export {
  Bell,
  ChevronRight,
  ChevronDown,
  GripVertical,
  Loader2,
  ScrollText,
  Settings,
  Tag,
} from 'lucide-react';
